import { Box } from "@mui/material";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { planTypes } from "utils/Types";
import NoPropertyPlansBanner from "../IndividualProperty/NoPropertyPlansBanner";
import AddNewSection from "./AddNewSection";
import Item from "./Item/index";

export default function Sections({ selectedPlanDetail, planType }: any) {
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const location = useLocation();
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const pageName = filterPage.libraryPlanDetailsDisplay;
  return (
    <>
      {isCorp &&
        planType !== planTypes.MyPlans &&
        (location?.state?.innCode ? location?.state?.innCode === "CORP" : innCode === "CORP") && (
          <>
            <Box marginTop={"-12px"} display={"flex"} justifyContent={"space-between"}>
              <Box></Box>
              <GlobalFilters filterButtonName="Variant Plan Filter" page={pageName} />
            </Box>
            <GlobalFilterDescription page={pageName} bgColor={tokens.Text.General.Inverse} />
          </>
        )}
      {selectedPlanDetail?.sections?.length > 0 ? (
        selectedPlanDetail?.sections?.map((section: any, index: number) => {
          return (
            <Item
              key={section.id}
              section={section}
              index={index}
              planType={planType}
              planId={selectedPlanDetail?.id}
            />
          );
        })
      ) : (
        <NoPropertyPlansBanner bgColor={tokens.Background.General.Primary} message={"You have no Results"} />
      )}

      {planType === planTypes.MyPlans && <AddNewSection label="Add new section" accessType={accessTypes.update} />}
    </>
  );
}
